import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { formatBonusAmount } from '../parseWalletAmount.js';
import { FormatDate } from '../Function';

import { Link } from "react-router-dom";

function Index() {
  const [productcategorydata, setproductcategorydata] = useState([]);
  const { user, fulluser } = useContext(AuthContext);

  const [data, setdata] = useState([]);


  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);

  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };

  useEffect(() => {
    getUserdetails();
  }, [user]);

  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/Monthlybonustransactions", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          console.log(res.data.wallet);
          if (res.data.status == 'success') {
            setdata(res.data.wallet);

          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };


  return (
    <div><div className="min-vh-100">
      {/* Navbar */}
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Monthly Rewards points</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <div className="row justify-content-center mt-2 p-2">

        {data.map((shop, index) => (
          <div className="col-12 p-1">
            <Link  state={{ shop }}>
              <Col xs={12} key={index} className="">
                <Card >
                  <Card.Body>
                    <div className='row'>
                      <div className='col-4'>
                        <center><img src={'./star.png'} className="shoplist_img" /></center>

                      </div>
                      <div className='col-8'>
                        <h3><span className="shoplist_text">Bonus Coins.{formatBonusAmount(shop)}</span></h3>
                        <p className="shoplist_dcr">Date : {FormatDate(shop.created_at)}</p>
                        <p className="shoplist_dcr">Type : {shop.slug}</p>

                      </div>
                    </div>
                  </Card.Body>

                </Card>
              </Col>
            </Link>
          </div>

        ))}
      </div>

    </div>
    </div>
  )
}
export default Index